var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"targets-type",class:{ 'targets-type--with-label': _vm.label }},[_c(_setup.TargetsTypeIcon,{staticClass:"targets-type__icon",attrs:{"icon":_setup.iconValue}}),(_vm.label)?_c('span',{staticClass:"targets-type__label"},[_vm._v(_vm._s(_setup.typeLabel))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }